import { defineStore } from 'pinia'

import applicationApi from '@/api/application'
import { useMainStore } from './main'

const successStatusCode = 1000

export const useApplicationStore = defineStore('application', {
  state: () => ({
    applicationStatus: {},
    applicationStatusError: {}
  }),

  actions: {
    getApplicationStatus({ data, success, fail } = {}) {
      useMainStore().loaderView(true)
      applicationApi.getApplicationStatus(data).then(
        response => {
          if (response.body.status && (response.body.status.code === successStatusCode)) {
            this.applicationStatus = response.body.responseObject
          }
          else {
            this.applicationStatusError = response.body.status
          }
          success && success(response)
          useMainStore().loaderView(false)
        }, response => {
          fail && fail(response)
        })
    }
  }

},)